<script setup>
    import { ref, computed } from 'vue'
    import SingleEdit from '@/js/components/Common/SingleEdit.vue'
    import { TextField } from '@/js/components/Common'

    const props = defineProps({
        modulTyp: {
            type: String,
            required: true
        },
        allowEdit: {
            type: Boolean,
            required: false,
            default: () => false
        },
        tooltip: {
            type: String,
            required: false,
            default: () => ''
        },
        language: {
            type: String,
            required: false,
            default: () => 'deutsch'
        }
    })

    const title = computed(() => (props.language === 'englisch' ? 'Module type | Modultyp' : 'Modultyp'))

    const emit = defineEmits(['modulTypSaved'])

    const editModulTyp = ref('')

    function handleEditStart() {
        editModulTyp.value = props.modulTyp
    }

    function handleEditAbort() {
        editModulTyp.value = ''
    }

    const saveModulTyp = () => {
        emit('modulTypSaved', editModulTyp.value)
    }
</script>

<template>
    <single-edit
        :entry="modulTyp"
        :title="title"
        edit-key="modulTyp"
        :allow-edit="allowEdit"
        :tool-tip="tooltip"
        @text-saved="saveModulTyp"
        @edit-aborted="handleEditAbort"
        @edit-started="handleEditStart"
    >
        <template #edit-component>
            <common-textarea-field v-model="editModulTyp" class="w-100 h-100" />
        </template>
    </single-edit>
</template>

<style scoped lang="scss"></style>
